<template>
  <div class="orcamento-digitacao">    
    <g-card class="card-orcamento-em-digitacao" ref="cardDeBusca" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Orçamentos em Digitação </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="clear"
            />
            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            v-on:acao="buscar"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="conteudo-orcamento-digitacao espacamento-filtros">
          <div class="unidade">
            <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
            <PDropDown
            class="unidade-input input-label"
            optionLabel="nome"
            optionValue="id"
            placeholder="TODAS"
            v-model="formSearch.UnidadeId"
            :options="EmpresaArray"
            >
            </PDropDown>
          </div>

          <div class="cliente">
            <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
            <!-- <PDropDown
            class="cliente-input input-label"
            optionLabel="nomeFantasia"
            optionValue="id"
            placeholder="Selecione o Cliente"
            v-model="formSearch.CLienteId"
            :filter="true"
            :options="dataClientes"
            @filter="buscarClientes($event.value)"
            >
              <template #option="slotProps">
                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
              </template>
            </PDropDown> -->
            <cliente-dropdown 
              class="cliente-input input-label"
              v-model="formSearch.CLienteId"
              :empresaId="formSearch.UnidadeId"
              :representanteId="this.$store.state.representanteSelecionadoId"
            />
          </div>

          <div class="data-digitacao">
            <div class="periodo-emissao-titulo titulo-conteudo-filtros"> Data de Digitação </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="data-digitacao-inicio-input input-label"
                invertido
                largurainput="100%"
                tamanhobotao = "35px"
                placeholderinput="Início"
                :dataPassadas="true"
                v-model="formSearch.DataInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="data-digitacao-termino-input input-label"
                invertido
                largurainput="100%"
                tamanhobotao = "35px"
                placeholderinput="Término"
                :dataPassadas="true"
                v-model="formSearch.DataFim"
                ></g-date-input>
              </div>
            </div>
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="15px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        @click="buscar"
        >
        BUSCAR
        </g-button>
      </div>
    </g-card>

    <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      TextoVazio="Nenhum Orçamento Encontrado"
      Titulo="Orçamentos em Digitação"
      :colunas="Colunas"
      :Paginacao="true"
      :numeroBotoesAcao="1"
      :valores="OrcamentoArray"
      :NumeroLinhas="100"
      :Filtros="Filtro"
      :FiltrosEspecificos = "true"
      :Editavel= "false"
      :rowEditor="true"
      :Excluivel="true"
      v-on:excluir="excluirOrcamentoDigitacao"
      :checkprancheta = "false"
      v-on:duploClickLinha="abrePopup"
      v-on:clickImprimir="imprimir"
      :campoAgrupador="'empresaCliente'"
      :campoExibicaoGrupo="'empresaCliente'"
      altura="auto"
      ></g-data-table>
    </g-card>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popup" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja continuar a editar as informações do orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopup"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="redireciona"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>

    <PDialog :showHeader="false" :closable="false" v-model:visible="confirmacaoExclusao">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja mesmo excluir este orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="confirmacaoExclusao = false"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="confirmarExclusaoOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>


<script>
import orcamentoemdigitacao from './orcamentoemdigitacao.js'
export default orcamentoemdigitacao
</script>

<style scoped>
@media (min-width:310px) {

}

@media (min-width:368px) {

}

@media (min-width:600px) {
.conteudo-orcamento-digitacao {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 20px;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.data-digitacao { grid-area: 2 / 1 / 3 / 2; }
}

@media (min-width:650px) {
.popups-consultar-orcamentos {
  width: 26em;
}
}

@media (min-width:801px) {

}

@media (min-width:1025px) {
.conteudo-orcamento-digitacao {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.data-digitacao { grid-area: 1 / 3 / 2 / 4; }
}

@media (min-width:1281px) {
.conteudo-orcamento-digitacao {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.data-digitacao { grid-area: 1 / 3 / 2 / 4; }
}

@media (min-width:1500px) {

}

</style>
